module.exports = __webpack_public_path__ + "static/media/community-no-uploads-video.d079ff58.svg";